import axios from './configAxiosClean'

export const postTerminalAccessForUserApi = async (requestData, user_id) => {
    return axios.post(`/staff/${user_id}/terminal/access/set/`, requestData);
  };
